export default {
  shoutSectionV2a: {
    container: {
      width: '100%',
      flexDirection: ['column', 'row'],
      fontSize: [4, 4, 5, 6],
      justifyContent: 'center'
    },
    content: {
      order: '1',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: ['flex-start', 'flex-start', 'center'],
      padding: 4,
      color: 'text',
      width: ['100%', '70%', '50%'],
      flexGrow: '1'
    },
    title: {
      textAlign: ['left', 'left', 'center'],
      width: '100%',
      fontSize: '1.5rem',
      borderBottom: ['1px solid black', '', 'none'],
      padding: '0.25rem 0rem',
      marginBottom: '0.5rem',
      color: 'primary'
    },
    text: {
      textAlign: ['left', 'left', 'center'],
      maxWidth: '500px',
      margin: '0 auto',
      fontSize: '1em',
      width: '100%'
    },
    date: {
      textAlign: ['left', 'left', 'center'],
      fontSize: '0.75em',
      margin: '0.5rem auto 0rem',
      maxWidth: '500px',
      width: '100%',
      order: '3',
      opacity: '0.8'
    },
    imageContainer: {
      position: 'relative',
      width: ['100%', '30%', '50%'],
      flexGrow: '1',
      order: '2',
      img: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        objectFit: 'cover'
      },
      '::before': {
        content: "''",
        position: 'absolute',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        zIndex: '100',
        background: [
          '',
          '',
          'linear-gradient(270deg,rgb(255 255 255 / 0%),rgb(255 255 255 / 0%) 0%,rgb(255 255 255 / 0%) 50%,rgb(255 255 255 / 10%) 75%,rgb(255 255 255))'
        ]
      }
    },
    imageFill: {
      paddingBottom: '100%'
    },
    shoutCTAS: {
      flexWrap: 'wrap',
      marginBottom: '0.5rem',
      transition: 'all ease-in-out 0.3s'
    },
    shoutCTA: {
      variant: 'buttons.primary',
      margin: '0.5rem 1rem 0.5rem 0rem'
    }
  }
}
